<div class="flex h-screen w-screen flex-col">
  <palantir-progress-bar
    *ngIf="loadingService.isLoading | async"
    class="fixed top-0 z-[999999] self-stretch"
    mode="indeterminate"
    style="width: 100%"
  ></palantir-progress-bar>

  <div class="flex size-full overflow-hidden">
    <fx-sidebar />

    <div
      class="duration-250 palantir-scrollbar size-full overflow-hidden bg-neutrals-background-default transition-all"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
